<script lang="ts">
import katexify from './functions/katexify';

	import uqnSplit from './functions/uqnSplit';
	import Fraction from './functions/fractionClass';
	//import katexify from './functions/katexify';
	//import brackets from './functions/brackets';

	export let uqn: number;

	let pAB:string, pC:string, thirdP:string;
	$: [pAB, thirdP, pC] = uqnToQn2203(uqn);

	function uqnToQn2203(u:number):string[]{
		const [type,a,b,c,k] = uqnSplit(u);
		let pAB:string, pC:string, thirdP:string;
		if (type<6){ // types 1 and 2
			if (type<5){ // 1: a cap b, 2: a | b, 3: a | b', 4: a' | b
				pAB = `{P(A)=${new Fraction(a,10).toString()},} \\allowbreak {P(B)=${new Fraction(b,10).toString()}}`;
				// intersect must be between a+b-1 and min(a,b);
				const upperBound = Math.min(a,b);
				const lowerBound = Math.max(a+b-10,0);
				const intersectFrac = new Fraction(10*lowerBound+k*(upperBound-lowerBound),100);
				const subtype = type%4;
				if (subtype==1){
					thirdP = `P(A \\cap B)=${intersectFrac.toString()}.`;
				} else if (subtype==2){
					thirdP = `P(A \\mid B)=${intersectFrac.divide(new Fraction(b,10)).toString()}.`;
				} else if (subtype==3){
					thirdP = `P(A \\mid B')=${new Fraction(a,10).minus(intersectFrac).divide(new Fraction(10-b,10)).toString()}.`;
				} else{
					thirdP = `P(A' \\mid B)=${new Fraction(b,10).minus(intersectFrac).divide(new Fraction(b,10)).toString()}.`;
				}
				pC = `P(C)=${new Fraction(c,10).toString()}.`
			} else{ //5: given a intersect b intersect c.
				pAB = `{P(A)=${new Fraction(a,10).toString()},} \\allowbreak {P(B)=${new Fraction(b,10).toString()},} \\allowbreak {P(C)=${new Fraction(c,10).toString()}}`;
				const upperBound = Math.min(a*b,a*c,b*c,a*b+a*c-a*10+100,a*b+b*c-10*b+100,a*c+b*c-10*c+100,100,100-a*10-b*10-c*10+a*b+b*c+a*c);
				const lowerBound = Math.max(a*b-100,a*c-100,b*c-100,a*b+a*c-a*10,a*b+b*c-10*b,a*c+b*c-10*c,0);
				const intersectFrac = new Fraction(10*lowerBound+k*(upperBound-lowerBound),1000);
				thirdP = `P(A \\cap B \\cap C)=${intersectFrac.toString()}.`;
			}
			return [pAB, thirdP, pC]
		} else{ // 6: mutually exclusive
			pAB = `{P(A)=${new Fraction(a,10).toString()},} \\allowbreak {P(B \\cap C)=${new Fraction(b*(10-a),100).toString()}}`;
			thirdP = `{P(A' \\cap B' \\cap C')=${new Fraction(c*(10-a),100).toString()}}`;
			return [pAB, thirdP]
		}
	}
</script>

{#if Number(uqn.toString()[0])<5}
<p>
	For events {@html katexify('A')} and {@html katexify('B')} it is given that {@html katexify(pAB,false)}
	and {@html katexify(thirdP)}
</p>
<div>(3 marks) (a) Find {@html katexify('P\\left(A\\cup B\\right).')}</div>
<p>
	For a third event {@html katexify('C')} it is given that {@html katexify(pC)}
	and that {@html katexify('A')} and {@html katexify('C')} are independent.
</p>
<div>(2 marks) (b) Find {@html katexify("P\\left(A'\\cap C\\right).")}</div>
<div>(4 marks) (c) Find the range of possible values of {@html katexify("P\\left(A'\\cap B \\cap C\\right).")}</div>
{:else if Number(uqn.toString()[0])==5}
<p>
	For events {@html katexify('A,B')} and {@html katexify('C')} it is given that {@html katexify(pAB,false)}
	and {@html katexify(thirdP)}
</p>
<p>
	It is also given that events {@html katexify('A')} and {@html katexify('B')} are independent, and that
	events {@html katexify('A')} and {@html katexify('C')} are independent.
</p>
<div>(3 marks) (a) Find {@html katexify('P\\left(A\\cup B\\right).')}</div>
<div>(3 marks) (b) Given also that events {@html katexify('B')} and {@html katexify('C')} are independent, find {@html katexify("P(A'\\cap B' \\cap C').")}</div>
<div>(4 marks) (c) Given instead that we do not know if {@html katexify('B')} and {@html katexify('C')} are independent, find the maximum and
	minimum possible value of {@html katexify("P(A'\\cap B' \\cap C').")}</div>
{:else}
<p>
	The events {@html katexify('A,B')} and {@html katexify('C')} are such that {@html katexify('{P(A)=a,} \\allowbreak {P(B)=b}',false)}
	and {@html katexify('P(C)=c.')}
</p>
<p>
	It is also given that events {@html katexify('A')} and {@html katexify('B')} are independent, and that
	events {@html katexify('A')} and {@html katexify('C')} are mutually exclusive.
</p>
{#if Number(uqn.toString()[4])==1}
<div>
	(2 marks) (a) Find an expression for {@html katexify("P\\left(A'\\cap B\\right)")} and hence prove that
	{@html katexify("A'")} and {@html katexify("B")} are independent events.
</div>
{:else if Number(uqn.toString()[4])==2}
<div>
	(2 marks) (a) Find an expression for {@html katexify("P\\left(A\\cap B'\\right)")} and hence prove that
	{@html katexify("A")} and {@html katexify("B'")} are independent events.
</div>
{:else}
<div>
	(2 marks) (a) Find an expression for {@html katexify("P\\left(A'\\cap B'\\right)")} and hence prove that
	{@html katexify("A'")} and {@html katexify("B'")} are independent events.
</div>
{/if}
<p>
	It is now given that {@html katexify(pAB,false)} and {@html katexify(thirdP)}
</p>
<div>(4 marks) (b) Find the greatest and
	least possible value of {@html katexify("P(A\\cap B).")}</div>
{/if}